import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import Check from '@mui/icons-material/Check';
import Clear from '@mui/icons-material/Clear';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

import CloseButton from './CloseButton.tsx';
import PaperComponent from '../PaperComponent';

import api from '../../utils/api.ts';

import {
  setAlertsSnackbarOpen,
  setAlertsSnackbarSeverity,
  setAlertsSnackbarText,
} from '../../features/app/alertsSnackbarSlice';
import { setConfirmClearNotificationsDialogOpen } from '../../features/app/dialogsSlice';
import { resetNotifications } from '../../features/app/notificationsSlice';

import { borderedDialogPaperProps } from '../../theme';

const ConfirmClearNotificationsDialog: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [deleteButtonDisabled, setDeleteButtonDisabled] = useState(false);
  const open = useSelector((state: any) => state.dialogs.confirmClearNotificationsDialogOpen);

  const handleClose = () => {
    dispatch(setConfirmClearNotificationsDialogOpen(false));
  };

  const handleDelete = async () => {
    if (deleteButtonDisabled) { return };
    setDeleteButtonDisabled(true);

    await api.delete('/notifications/').then(response => {
      if (response.status === 200) {
        dispatch(resetNotifications());
        handleClose();
        dispatch(setAlertsSnackbarSeverity('info'));
        dispatch(setAlertsSnackbarText(t('Cleared all notifications.')));
        dispatch(setAlertsSnackbarOpen(true));
      };
    }).catch(err => {
      dispatch(setAlertsSnackbarSeverity('error'));
      dispatch(setAlertsSnackbarText(t('Something went wrong.')));
      dispatch(setAlertsSnackbarOpen(true));

      setTimeout(() => {
        setDeleteButtonDisabled(false);
      }, 1500);
    });
  };

  useEffect(() => {
    if (!open) setDeleteButtonDisabled(false);
  }, [open]);

  return (
    <Dialog
      open={open}
      PaperComponent={PaperComponent}
      hideBackdrop={false}
      aria-labelledby="draggable-dialog-title"
      aria-describedby="alert-dialog-description"
      {...borderedDialogPaperProps}
      sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
    >
      <DialogTitle textAlign="center" style={{ cursor: 'move' }} id="draggable-dialog-title">
        {t('Confirm clear all')}
      </DialogTitle>
      <CloseButton onClick={handleClose} />
      <form>
        <DialogContent>
          <Typography>
          </Typography>
          <DialogContentText id="alert-dialog-description">
            {t('Are you sure you want to clear all notitications?')}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button variant="outlined"
            startIcon={<Clear />}
            onClick={handleClose}>
            {t('Cancel')}
          </Button>
          <Button
            disabled={deleteButtonDisabled}
            onClick={handleDelete}
            variant="outlined"
            endIcon={<Check />}
            color="error"
          >
            {t('Clear')}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ConfirmClearNotificationsDialog;